import moment from 'moment';

export const getDefaultYear = (metricYears) => {
    let currentYear = moment().year();
    return metricYears.includes(currentYear) ? currentYear : Math.max(...metricYears);
};

export const metricYear2Grid = (metricYear, isCashFlow) => {
    const convertYear = (category) => {
        return [
            { value: metricYear[category].jan },
            { value: metricYear[category].feb },
            { value: metricYear[category].mar },
            { value: metricYear[category].apr },
            { value: metricYear[category].may },
            { value: metricYear[category].jun },
            { value: metricYear[category].jul },
            { value: metricYear[category].aug },
            { value: metricYear[category].sep },
            { value: metricYear[category].oct },
            { value: metricYear[category].nov },
            { value: metricYear[category].dec },
        ]
    };
    if (metricYear) {
      const value = [
        convertYear('baseline'),
        convertYear('target'),
        convertYear('actual')
      ];
      if(isCashFlow) {
          value.push(convertYear('forecast'));
      }
      return value;
    }
    return emptyGrid;
};

export const emptyGrid = [
    [ { value: null }, { value: null }, { value: null }, { value: null }, { value: null }, { value: null },
    { value: null }, { value: null }, { value: null }, { value: null }, { value: null }, { value: null } ],
    [ { value: null }, { value: null }, { value: null }, { value: null }, { value: null }, { value: null },
    { value: null }, { value: null }, { value: null }, { value: null }, { value: null }, { value: null } ],
    [ { value: null }, { value: null }, { value: null }, { value: null }, { value: null }, { value: null },
    { value: null }, { value: null }, { value: null }, { value: null }, { value: null }, { value: null } ],
];

export const rows = [
    { name: 'Baseline' },
    { name: 'Target' },
    { name: 'Actual' }
];


export const cashFlowRows = [
  { name: 'Baseline' },
  { name: 'Target' },
  { name: 'Actual' },
  { name: 'Forecast' }
];

export const performanceCashRows = [
  { name: 'Target' },
  { name: 'Forecast' },
  { name: 'Actual' }
];

export const columns = [
    { name: 'jan' },
    { name: 'feb' },
    { name: 'mar' },
    { name: 'apr' },
    { name: 'may' },
    { name: 'jun' },
    { name: 'jul' },
    { name: 'aug' },
    { name: 'sep' },
    { name: 'oct' },
    { name: 'nov' },
    { name: 'dec' }
];

export const updateGrid = (grid, updates) => {
    const newGrid = JSON.parse(JSON.stringify(grid));
    updates.forEach(({row, col, value}) => {
        newGrid[row][col].value = value;
    });
    return newGrid;
};

export const updateMetricData = (updates, isCashFlow = false) => {
    const changeSet = {};
    let theRows = isCashFlow ? cashFlowRows : rows
    updates.forEach(({row, col, value}) => {
        changeSet[`${columns[col].name}${theRows[row].name}`] = value ? String(value).replace('$', '').replace(',', '') * 1 : null;
    });
    return changeSet;
};
